// First-touch acquisition attribution (sep 2026) — captures how a visitor
// first found Tovías (UTM params, or referrer domain like instagram.com /
// google.com) so the admin panel can show "de dónde vienen los clientes"
// for marketing decisions. Never overwrites once captured.
const FIRST_TOUCH_KEY = 'tovias_first_touch_v1';
const SENT_KEY = 'tovias_attribution_sent_v1';

const KNOWN_DOMAINS = [
  { test: (h) => h.includes('instagram'), source: 'instagram' },
  { test: (h) => h.includes('tiktok'), source: 'tiktok' },
  { test: (h) => h.includes('google'), source: 'google' },
  { test: (h) => h.includes('facebook') || h.includes('fb.com'), source: 'facebook' },
  { test: (h) => h.includes('youtube'), source: 'youtube' },
  { test: (h) => h.includes('bing'), source: 'bing' },
  { test: (h) => h.includes('twitter') || h.includes('t.co') || h.includes('x.com'), source: 'twitter' },
  { test: (h) => h.includes('whatsapp'), source: 'whatsapp' },
];

export const captureFirstTouch = () => {
  try {
    if (localStorage.getItem(FIRST_TOUCH_KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get('utm_source');
    let payload = null;
    if (utmSource) {
      payload = {
        utm_source: utmSource.toLowerCase().slice(0, 60),
        utm_medium: (params.get('utm_medium') || '').toLowerCase().slice(0, 60) || null,
        utm_campaign: (params.get('utm_campaign') || '').toLowerCase().slice(0, 80) || null,
        referrer_domain: null,
        landing_path: window.location.pathname,
      };
    } else if (document.referrer) {
      try {
        const refHost = new URL(document.referrer).hostname.replace(/^www\./, '');
        if (refHost && refHost !== window.location.hostname && !refHost.includes('tovias.app')) {
          const known = KNOWN_DOMAINS.find((k) => k.test(refHost));
          payload = {
            utm_source: known ? known.source : null,
            utm_medium: known ? 'organic' : null,
            utm_campaign: null,
            referrer_domain: refHost.slice(0, 100),
            landing_path: window.location.pathname,
          };
        }
      } catch { /* invalid referrer URL — ignore */ }
    }
    if (payload) localStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify(payload));
  } catch { /* private mode / storage disabled — non-blocking */ }
};

export const getFirstTouchAttribution = () => {
  try {
    const raw = localStorage.getItem(FIRST_TOUCH_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

export const sendAttributionPing = async (apiBase) => {
  try {
    if (localStorage.getItem(SENT_KEY)) return;
    const data = getFirstTouchAttribution();
    if (!data) { localStorage.setItem(SENT_KEY, '1'); return; }
    await fetch(`${apiBase}/auth/attribution`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(data),
    });
    localStorage.setItem(SENT_KEY, '1');
  } catch { /* best-effort, never block the app */ }
};
